import { getDropOffWayPoint } from '@bringg-frontend/utils';

import { handleUnassignTask } from '../../routes-planner-data-creator/routes-planner-data-creator';

const convert = task => {
	let updatedTask = { ...task };
	updatedTask.way_points = [getDropOffWayPoint(task)];

	if (task.aggregations) {
		updatedTask.aggregations = { ...task.aggregations };
	}

	const runId = updatedTask.run_id;
	if (runId == null) {
		updatedTask = handleUnassignTask(updatedTask);
	}
	return updatedTask;
};

export const routesPlannerTasksConverter = { convert };
